import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy() {
    if (!navigator.clipboard) {
      window.dispatchEvent(
        new CustomEvent("toast:show", {
          detail: {
            message: "Clipboard unavailable.",
            type: "error"
          }
        })
      )

      return
    }

    navigator.clipboard
      .writeText(this.textValue)
      .then(() => {
        const button = this.element
        button.classList.remove("text-accent", "hover:text-accent-hover")
        button.classList.add("text-success")

        setTimeout(() => {
          button.classList.remove("text-success")
          button.classList.add("text-accent", "hover:text-accent-hover")
        }, 1000)

        // Dispatch toast event
        window.dispatchEvent(
          new CustomEvent("toast:show", {
            detail: {
              message: `Copied "${this.textValue}" to clipboard`,
              type: "success"
            }
          })
        )
      })
      .catch((err) => {
        console.error("Failed to copy:", err)
        window.dispatchEvent(
          new CustomEvent("toast:show", {
            detail: {
              message: "Failed to copy to clipboard",
              type: "error"
            }
          })
        )
      })
  }
}
